import definition from './help.service';

/**
 * HelpService settings
 * @type {{name: string, definition: HelpService}}
 */
const Service = {
    name: 'HelpService',
    definition
};

export {
    Service
};



// WEBPACK FOOTER //
// ./app/services/help/index.js